<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { computed } from 'vue';
import AuthenticatedMediaImage from './AuthenticatedMediaImage.vue';

const props = defineProps({
  media: { type: Array, default: () => [] },
});

const layouts = {
  1: ['a a a a a a'],
  2: ['a a a b b b'],
  3: ['a a a a b b', 'a a a a c c'],
  4: ['a a a b b b', 'c c c d d d'],
  5: ['a a a b b b', 'c c d d e e'],
  6: ['a a b b c c', 'd d e e f f'],
  7: ['a a a b b b', 'c c d d e e', 'f f f g g g'],
  8: ['a a a b b b', 'c c d d e e', 'f f g g h h'],
  9: ['a a b b c c', 'd d e e f f', 'g g h h i i'],
  10: ['a a a b b b', 'c c d d e e', 'f f g g h h', 'i i i j j j'],
};

const items = computed(() => props.media.slice(0, 10));
const rows = computed(() => layouts[items.value.length] || layouts[10]);
const albumClass = computed(() => {
  const count = items.value.length;
  if (count <= 2) return 'aspect-[4/3]';
  if (count <= 4) return 'aspect-square';
  if (count <= 6) return 'aspect-[5/4]';
  return 'aspect-[4/5] sm:aspect-square';
});
const albumStyle = computed(() => ({
  gridTemplateAreas: rows.value.map(row => `"${row}"`).join(' '),
  gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
  gridTemplateRows: `repeat(${rows.value.length}, minmax(0, 1fr))`,
}));

const tileStyle = index => ({ gridArea: String.fromCharCode(97 + index) });
</script>

<template>
  <div
    class="grid w-full gap-0.5 overflow-hidden bg-n-solid-1"
    :class="albumClass"
    :style="albumStyle"
    data-telegram-media-album="tg_publication_media_album"
  >
    <div
      v-for="(item, index) in items"
      :key="item.id"
      class="relative min-h-0 min-w-0 overflow-hidden bg-n-alpha-2"
      :style="tileStyle(index)"
      :data-album-index="index"
    >
      <AuthenticatedMediaImage
        :src="item.preview_url"
        :alt="item.filename || 'Изображение публикации'"
        class="absolute inset-0 size-full"
        image-class="size-full object-cover"
        placeholder-class="flex size-full flex-col items-center justify-center gap-2 p-2 text-center text-xs text-n-slate-10"
      />
    </div>
  </div>
</template>
